var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.541 11.9165V10.0832H8.79095V7.33317L6.95762 7.33317V10.0832H4.20762V11.9165L6.95762 11.9165V14.6665H8.79095V11.9165H11.541ZM18.8004 12.8332V5.49984C18.8004 4.4915 17.9754 3.6665 16.967 3.6665L3.66668 3.6665C2.65835 3.6665 1.83335 4.48234 1.83335 5.49067V16.4998C1.83335 17.5082 2.65835 18.3332 3.66668 18.3332H13.3004L18.8004 12.8332ZM3.66668 16.4998V5.49984L16.967 5.49984V11.9165H12.3837V16.4998H3.66668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdd);
export default __webpack_public_path__ + "static/media/note_add.cb9343f9.svg";
export { ForwardRef as ReactComponent };